<template>
	<h3 class="shared-list-quick-filter-title">
		{{ $t('common.shared.components.listQuickFilter.title') }}
	</h3>

	<div class="shared-list-quick-filter">
		<!-- <shared-tag-quick-filter
			v-if="setup.self.isClient() || setup.self.isAgency() && !hideTagFilter"
			v-model="setup.filter.tagIds"
			@update:model-value="filterService.applyWithRouterAsync(true)"/> -->

		<o-chips
			v-for="(quickFilter, index) in setup.quickFilters"
			:key="index"
			:outline="setup.getQuickFilterColor(quickFilter) === 'info'"
			:color="setup.getQuickFilterColor(quickFilter)"
			@click="setup.applyQuickFilter(quickFilter)">
			{{ quickFilter?.label }}

			<template
				v-if="quickFilter?.dual"
				#dual>
				{{ quickFilter?.dual }}
			</template>
		</o-chips>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedListQuickFilterEmits, SharedListQuickFilterProps } from './SharedListQuickFilterSetup';
import SharedListQuickFilterSetup from './SharedListQuickFilterSetup';
const emits = defineEmits<SharedListQuickFilterEmits>() as SharedListQuickFilterEmits;
const props = withDefaults(defineProps<SharedListQuickFilterProps>(), SharedListQuickFilterSetup.defaultProps);
const setup = new SharedListQuickFilterSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
@import "@/styles/variables.less";

.shared-list-quick-filter {
	display: flex;
	flex-wrap: wrap;
	gap: 0.75rem;
	align-items: center;
	justify-content: flex-end;

	:deep(.orion-chips) {
		cursor: pointer;
		transition: opacity 0.3s;

		&:hover {
			opacity: 0.7;
		}
	}

	&-title {
		display: none;
		margin: var(--space-md) 0 var(--space-sm);
		font-weight: var(--font-weight-section-title);
	}

	#left-aside > & {
		justify-content: flex-start;

		&-title {
			display: block;

			> &:first-child {
				margin-top: 0.5rem;
			}
		}
	}

	@media @phone {
		justify-content: flex-start;
	}
}
</style>
